import { render, staticRenderFns } from "./TicketHistoryComponent.vue?vue&type=template&id=4649eabc&scoped=true"
import script from "./TicketHistoryComponent.vue?vue&type=script&lang=js"
export * from "./TicketHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./TicketHistoryComponent.vue?vue&type=style&index=0&id=4649eabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649eabc",
  null
  
)

export default component.exports